import DefaultLayout from '@core/components/Layouts/Default/DefaultLayout';
import { HeaderProps } from '@core/components/Layouts/Default/Header/Header';
import { pageContentLoader } from '@core/components/Loader/Content/ContentLoader';
import Meta from '@core/components/Meta/Meta';
import { getUrlWithPath } from '@core/utils/url';
import { ReactElement, useMemo } from 'react';
import { useParams } from 'react-router';
import { routes } from '../../../constants/routes';
import { useCmsPage } from '../../cms/hooks/useCmsPage';
import { defaultPageTypes, useCmsPagesTopMenu } from '../../cms/hooks/useCmsPagesMenu';
import NotFound from '../NotFound';

const hideHeaderProps: HeaderProps = {
  auth: false,
  host: false,
  dashboard: false,
  defaultItems: false,
};

// generic route used for CMS pages
const Page = (): ReactElement => {
  const { slug } = useParams<{ slug: string }>();
  const { isLoading, meta, page, ui, headerProps } = useCmsPage(slug);
  const hideHeaderMenu = page ? page.hideHeaderMenu : true; // hide header menu until page setting is loaded
  const [, items] = useCmsPagesTopMenu(defaultPageTypes);

  const hProps = useMemo(
    () =>
      hideHeaderMenu
        ? { ...headerProps, ...hideHeaderProps }
        : { ...headerProps, defaultItems: false, menuItems: items },
    [headerProps, hideHeaderMenu, items],
  );

  if (!isLoading && (!page || !slug)) return <NotFound />;
  return (
    <DefaultLayout headerProps={hProps}>
      <Meta {...meta}>
        <link
          rel="canonical"
          href={getUrlWithPath().replace(routes.LANDING.link, routes.PAGE.link)}
        />
      </Meta>
      {isLoading ? pageContentLoader : ui}
    </DefaultLayout>
  );
};
export default Page;
